import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const PayloadBuilderToolbarActionsContext = createContext<(actions: React.ReactNode) => void>(() => {});

interface PayloadBuilderToolbarActionsProviderProps {
  children: React.ReactNode;
  onActionsChange: (actions: React.ReactNode) => void;
}

export function PayloadBuilderToolbarActionsProvider({
  children,
  onActionsChange,
}: PayloadBuilderToolbarActionsProviderProps) {
  const setActions = useMemo(() => onActionsChange, [onActionsChange]);

  return (
    <PayloadBuilderToolbarActionsContext.Provider value={setActions}>
      {children}
    </PayloadBuilderToolbarActionsContext.Provider>
  );
}

export function usePayloadBuilderToolbarActions(actions: React.ReactNode) {
  const setToolbarActions = useContext(PayloadBuilderToolbarActionsContext);

  useEffect(() => {
    setToolbarActions(actions);
    return () => setToolbarActions(null);
  }, [actions, setToolbarActions]);
}

export function usePayloadBuilderToolbarActionsState() {
  const [toolbarActions, setToolbarActions] = useState<React.ReactNode>(null);

  return { toolbarActions, setToolbarActions };
}
